import { createFileRoute } from '@tanstack/react-router';
import { PublicAppointmentFormPage } from '@/components/appointment-forms/PublicAppointmentFormPage';
import { PublicSignedFormPage } from '@/components/appointment-forms/PublicSignedFormPage';

interface OnlineFormSearch {
  appointmentId?: string;
}

export const Route = createFileRoute('/(public)/onlineform/$id')({
  validateSearch: (search: Record<string, unknown>): OnlineFormSearch => ({
    appointmentId: typeof search.appointmentId === 'string' ? search.appointmentId : undefined,
  }),
  component: OnlineFormPage,
});

function OnlineFormPage() {
  const { id } = Route.useParams();
  const { appointmentId } = Route.useSearch();
  return appointmentId ? (
    <PublicAppointmentFormPage appointmentId={appointmentId} formId={id} />
  ) : (
    <PublicSignedFormPage source={{ kind: 'signed-token', token: id }} />
  );
}
